import { BaseForm, FormModel } from '@ikegps/core-shared';
import { observable, makeObservable } from 'mobx';
import { addStyles } from '../components/theme';
import type { MithrilVNode } from '../mithril';
import { m } from '../mithril';
import { FormDesigner } from '../modules/form.designer/form.designer';
import { Services } from '../services';
import { CSS as FormEditPageCSS } from './form.edit.page';
import { IkePage, type IkePageConfig, IkePageName } from './page';
import { IkeToken } from '@ikegps/core-api';

const CSS = {
	container: 'c-FormEdit',
};

const Style = {
	[CSS.container]: {
		height: '100%',
		width: '80%',
	},
};

addStyles(Style);

export const FormEditNewPageConfig: IkePageConfig = {
	type: 'internal',
	name: IkePageName.formNew,
	path: '/form/new',
	auth: {
		required: true,
	},
};

export class FormEditNewPage extends IkePage {
	public form: FormModel | null = null;
	@observable.ref private designer: FormDesigner | null = null;

	constructor() {
		super(FormEditNewPageConfig);
		makeObservable(this);
	}

	init() {
		const hasVerticalSeparationToken = Services.Token.has(IkeToken.FEATURE_GROUP_IKE_ANALYZE);
		const baseForm = BaseForm.create(hasVerticalSeparationToken);

		this.form = baseForm.form;

		this.form.Mutator.displayName(`Base Form - ${Services.Department.current?.displayName ?? ''}`);
		this.form.Mutator.description('The default Base Form');

		this.designer = new FormDesigner();
		this.designer.setEditing(true);
		this.designer.isNewForm = true;
		this.designer.setForm(this.form);
	}

	get nodes(): MithrilVNode {
		if (Services.Department.current == null) {
			return null;
		}

		if (this.designer == null) {
			this.init();
		}

		if (!Services.User.current) {
			return null;
		}

		const userProfile = Services.UserProfile.get(Services.User.current.objectId);

		if (!userProfile || !Services.UserProfile.canEditForms(userProfile)) {
			return null;
		}

		return m(
			'div',
			{ className: `${FormEditPageCSS.container} ${CSS.container}`, key: 'new-form' },
			this.designer?.view()
		);
	}

	override onRemove() {
		if (this.designer != null) {
			this.designer.onRemove();
			this.designer = null;
		}
	}
}
